'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIExpandingTextArea from 'UIComponents/input/UIExpandingTextArea';
import UICharacterCounter from 'UIComponents/counters/UICharacterCounter';
import FormControlWithErrors from 'DesignEditorsUI/components/customWidgetEditor/sidebar/FormControlWithErrors';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import withDebouncedInput from 'DesignEditorsUI/components/shared/inputs/withDebouncedInput';
const DebouncedUICharacterCounter = withDebouncedInput(UICharacterCounter);

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.main.editorOptions.${key}`;

export default class EditorOptions extends Component {
  constructor(...args) {
    super(...args);

    this.onInlineHelpTextChange = e => {
      this.props.updateCustomWidget({
        inlineHelpText: e.target.value
      });
    };

    this.renderInlineHelpText = () => {
      const {
        inlineHelpText,
        isReadOnly,
        moduleErrors
      } = this.props;
      return /*#__PURE__*/_jsx(DebouncedUICharacterCounter, {
        counter: "down",
        max: 400,
        onChange: this.onInlineHelpTextChange,
        value: inlineHelpText,
        renderInput: ({
          count,
          onChange,
          value
        }) => {
          return /*#__PURE__*/_jsx(FormControlWithErrors, {
            characterCount: count,
            errors: moduleErrors.inline_help_text,
            isModuleError: true,
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('inlineHelpTextLabel')
            }),
            tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('inlineHelpTextTooltip')
            }),
            children: /*#__PURE__*/_jsx(SidebarInput, {
              disabled: isReadOnly,
              inputComponent: UIExpandingTextArea,
              minHeight: 70,
              onChange: onChange,
              value: value
            })
          });
        }
      });
    };
  }

  render() {
    return /*#__PURE__*/_jsx("div", {
      className: "custom-widget-editor-options",
      children: this.renderInlineHelpText()
    });
  }

}
EditorOptions.propTypes = {
  inlineHelpText: PropTypes.string,
  isReadOnly: PropTypes.bool.isRequired,
  moduleErrors: PropTypes.object.isRequired,
  updateCustomWidget: PropTypes.func.isRequired
};